import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-food-news',
  templateUrl: './food-news.component.html',
  styleUrls: ['./food-news.component.scss']
})
export class FoodNewsComponent {
  @Input() focused = false;
  @Input() imageSrc: string;
  @Input() date: string;
  @Input() newsText: string;
  @Input() newsInfo: string;
  @Input() buttons: string[];
  @Input() branchId: string;
  @Input() popupImageSrc: string;
  @Input() restaurantDetails: any;

  constructor(private modalService: NgbModal, private router: Router, private toastr: ToastrService) { }

  openModal(content: any) {
    this.modalService.open(content, { backdropClass: 'custom-backdrop', windowClass: 'custom-modal', centered: true });
  }

  navigateToRestaurant = () => {
    if (this.branchId) {
      this.router.navigate(['business-detail', this.branchId]);
      this.modalService.dismissAll();
    } else {
      this.toastr.error("Restaurant Details are not available for navigation for this record!");
    }
  }
}
